import PropTypes from 'prop-types';
export var overridableComponents = ['ActionIconArrowBottom', 'ActionIconArrowLeft', 'ActionIconArrowRight', 'ActionIconArrowTop', 'ActionIconBack', 'ActionIconCheckmark', 'ActionIconChevronBottom', 'ActionIconChevronLeft', 'ActionIconChevronRight', 'ActionIconChevronTop', 'ActionIconClose', 'ActionIconEye', 'ActionIconForward', 'ActionIconHeart', 'ActionIconMinus', 'ActionIconPaperPlane', 'ActionIconPlaceholder', 'ActionIconPlus', 'ActionIconScroll', 'ActionIconSearch', 'ActionIconShare', 'AlertBannerError', 'AlertBannerSuccess', 'AlertBannerWarning', 'AlertBlock',
/**
 * @deprecated removed with v7.0.0
 */
'AlertBlockError',
/**
 * @deprecated removed with v7.0.0
 */
'AlertBlockSuccess',
/**
 * @deprecated removed with v7.0.0
 */
'AlertBlockWarning', 'AtomLabel', 'Avatar', 'BoxSelectorBase',
/**
 * @missingPlatformSupport native
 */
'BoxSelectorOptionBase', 'BoxSelectorDetailedOption', 'ButtonPrimary', 'ButtonSecondary', 'ButtonTertiary', 'ButtonQuaternary', 'ButtonRoundPrimary', 'ButtonRoundSecondary', 'ButtonRoundTertiary', 'ButtonRoundQuaternary',
/**
 * @deprecated removed with v6.0.0
 */
'MoleculeButtonRoundPrimary',
/**
 * @deprecated removed with v6.0.0
 */
'ContextMenuMain',
/**
 * @deprecated removed with v6.0.0
 */
'ContextMenuNavigationItem',
/**
 * @deprecated removed with v6.0.0
 */
'ContextMenuSeparator',
/**
 * @deprecated removed with v6.0.0
 */
'ContextMenuSettingsItem', 'ComboBox', 'Dropdown', 'Field', 'Field.FieldTooltip', 'FieldLink', 'FieldSimple', 'IconAppLauncher', 'IconArrowBottom', 'IconArrowLeft', 'IconArrowRight', 'IconArrowTop', 'IconAssets', 'IconAssistant', 'IconAttachment', 'IconBack', 'IconBank', 'IconBanksCards', 'IconBenefits', 'IconCalendar', 'IconCart', 'IconCellphone', 'IconCheckmark', 'IconClock', 'IconClose', 'IconCreditCard', 'IconDebt', 'IconDelivery', 'IconDone', 'IconDownload', 'IconElephant', 'IconEnvelope', 'IconError', 'IconExclude', 'IconExpired', 'IconEye', 'IconFeedback', 'IconFeedbackConfirmation', 'IconFinancial', 'IconForward', 'IconGlasses', 'IconGridViewMode', 'IconHamburger', 'IconHandMoney', 'IconHeart', 'IconHelp', 'IconInformation', 'IconInstallment', 'IconLetter', 'IconListViewMode', 'IconLocation', 'IconMonthly', 'IconMore', 'IconNotification', 'IconOrder', 'IconOther', 'IconPadlock', 'IconPaperPlane', 'IconPension', 'IconPerson', 'IconPhone', 'IconPlaceholder', 'IconPlay', 'IconPlus', 'IconProduct', 'IconProfile', 'IconProfileAlternative', 'IconRecurring', 'IconRefresh', 'IconReturn', 'IconSalaryIncome', 'IconSavings', 'IconScale', 'IconSearch', 'IconServicePoint', 'IconSettings', 'IconShare', 'IconSign', 'IconSpeechBubble', 'IconSpendingCategories', 'IconStores', 'IconToDoorDelivery', 'IconToDoorDeliveryWithTimeslot', 'IconTransfers', 'IconTrash', 'IconTruck', 'IconWallet', 'IconWarning', 'KlarnaLogoFull', 'KlarnaLogoSingleLetter',
/**
 * @missingPlatformSupport native
 */
'Loader', 'MaskedField', 'MenuTab', 'NavBar', 'NavBarActionBase',
/**
 * @deprecated removed with v6.0.0
 */
'NavigationIconAssistant',
/**
 * @deprecated removed with v6.0.0
 */
'NavigationIconHome',
/**
 * @deprecated removed with v6.0.0
 */
'NavigationIconSpending',
/**
 * @deprecated removed with v6.0.0
 */
'NavigationIconShopping', 'NavigationIconSustainability',
/**
 * @deprecated removed with v6.0.0
 */
'NavigationIconTodo',
/**
 * @deprecated removed with v6.0.0
 */
'OfferBreakdown',
/**
 * @deprecated removed with v6.0.0
 */
'ParagraphPrimary',
/**
 * @deprecated removed with v6.0.0
 */
'ParagraphSecondary',
/**
 * @deprecated removed with v6.0.0
 */
'ParagraphTertiary',
/**
 * @deprecated removed with v6.0.0
 */
'ParagraphQuaternary', 'Preview',
/**
 * @deprecated removed with v6.0.0
 */
'PreviewLink',
/**
 * @deprecated removed with v6.0.0
 */
'PreviewWithOptions', 'ProgressBar', 'Radio.RadioOption', 'RadioBullet', 'RadioGroup', 'RadioResponsive', 'SelectorDirect', 'SelectorDirectOption', 'SelectorLogo', 'SelectorLogoOption', 'SelectorOptionBase', 'SelectorOptions', 'SpacerHorizontal', 'SpacerVertical', 'SwitchCheckbox', 'SwitchToggle',
/**
 * @deprecated removed with v6.0.0
 */
'TitleDefinition',
/**
 * @deprecated removed with v6.0.0
 */
'TitleDisplay',
/**
 * @deprecated removed with v6.0.0
 */
'TitlePrimary',
/**
 * @deprecated removed with v6.0.0
 */
'TitleSecondary',
/**
 * @deprecated removed with v6.0.0
 */
'TitleSubtitle',
/**
 * @deprecated removed with v6.0.0
 */
'TitleTertiary', 'Tooltip', 'Strong',
/**
 * @deprecated removed with v6.0.0
 */
'UpsellPreview'];
export var propTypes = {
  ActionIconArrowBottom: PropTypes.func,
  ActionIconArrowLeft: PropTypes.func,
  ActionIconArrowRight: PropTypes.func,
  ActionIconArrowTop: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  ActionIconBack: PropTypes.func,
  ActionIconCheckmark: PropTypes.func,
  ActionIconChevronBottom: PropTypes.func,
  ActionIconChevronLeft: PropTypes.func,
  ActionIconChevronRight: PropTypes.func,
  ActionIconChevronTop: PropTypes.func,
  ActionIconClose: PropTypes.func,
  ActionIconEye: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  ActionIconForward: PropTypes.func,
  ActionIconHeart: PropTypes.func,
  ActionIconMinus: PropTypes.func,
  ActionIconPaperPlane: PropTypes.func,
  ActionIconPlaceholder: PropTypes.func,
  ActionIconPlus: PropTypes.func,
  ActionIconScroll: PropTypes.func,
  ActionIconSearch: PropTypes.func,
  ActionIconShare: PropTypes.func,
  AlertBannerError: PropTypes.func,
  AlertBannerSuccess: PropTypes.func,
  AlertBannerWarning: PropTypes.func,
  AlertBlock: PropTypes.func,
  /**
   * @deprecated removed with v7.0.0
   */
  AlertBlockError: PropTypes.func,
  /**
   * @deprecated removed with v7.0.0
   */
  AlertBlockSuccess: PropTypes.func,
  /**
   * @deprecated removed with v7.0.0
   */
  AlertBlockWarning: PropTypes.func,
  AtomLabel: PropTypes.func,
  Avatar: PropTypes.func,
  BoxSelectorBase: PropTypes.func,
  /**
   * @missingPlatformSupport native
   */
  BoxSelectorOptionBase: PropTypes.func,
  // Also used for @bubble-contrib/molecule-box-selector-pricing-configurable-height
  BoxSelectorDetailedOption: PropTypes.func,
  ButtonPrimary: PropTypes.func,
  ButtonSecondary: PropTypes.func,
  ButtonTertiary: PropTypes.func,
  ButtonQuaternary: PropTypes.func,
  ButtonRoundPrimary: PropTypes.func,
  ButtonRoundSecondary: PropTypes.func,
  ButtonRoundTertiary: PropTypes.func,
  ButtonRoundQuaternary: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  MoleculeButtonRoundPrimary: PropTypes.func,
  // Contrib component
  /**
   * @deprecated removed with v6.0.0
   */
  ContextMenuMain: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  ContextMenuNavigationItem: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  ContextMenuSeparator: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  ContextMenuSettingsItem: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  ComboBox: PropTypes.func,
  // Contrib component
  Dropdown: PropTypes.func,
  Field: PropTypes.func,
  'Field.FieldTooltip': PropTypes.func,
  FieldLink: PropTypes.func,
  FieldSimple: PropTypes.func,
  IconAppLauncher: PropTypes.func,
  IconArrowBottom: PropTypes.func,
  IconArrowLeft: PropTypes.func,
  IconArrowRight: PropTypes.func,
  IconArrowTop: PropTypes.func,
  IconAssets: PropTypes.func,
  IconAssistant: PropTypes.func,
  IconAttachment: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  IconBack: PropTypes.func,
  IconBank: PropTypes.func,
  IconBanksCards: PropTypes.func,
  IconBenefits: PropTypes.func,
  IconCalendar: PropTypes.func,
  IconCart: PropTypes.func,
  IconCellphone: PropTypes.func,
  IconCheckmark: PropTypes.func,
  IconClock: PropTypes.func,
  IconClose: PropTypes.func,
  IconCreditCard: PropTypes.func,
  IconDebt: PropTypes.func,
  IconDelivery: PropTypes.func,
  IconDone: PropTypes.func,
  IconDownload: PropTypes.func,
  IconElephant: PropTypes.func,
  IconEnvelope: PropTypes.func,
  IconError: PropTypes.func,
  IconExclude: PropTypes.func,
  IconExpired: PropTypes.func,
  IconEye: PropTypes.func,
  IconFeedback: PropTypes.func,
  IconFeedbackConfirmation: PropTypes.func,
  IconFinancial: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  IconForward: PropTypes.func,
  IconGlasses: PropTypes.func,
  IconGridViewMode: PropTypes.func,
  IconHamburger: PropTypes.func,
  IconHandMoney: PropTypes.func,
  IconHeart: PropTypes.func,
  IconHelp: PropTypes.func,
  IconInformation: PropTypes.func,
  IconInstallment: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  IconLetter: PropTypes.func,
  IconListViewMode: PropTypes.func,
  IconLocation: PropTypes.func,
  IconMonthly: PropTypes.func,
  IconMore: PropTypes.func,
  IconNotification: PropTypes.func,
  IconOrder: PropTypes.func,
  IconOther: PropTypes.func,
  IconPadlock: PropTypes.func,
  IconPaperPlane: PropTypes.func,
  IconPension: PropTypes.func,
  IconPerson: PropTypes.func,
  IconPhone: PropTypes.func,
  IconPlaceholder: PropTypes.func,
  IconPlay: PropTypes.func,
  IconPlus: PropTypes.func,
  IconProduct: PropTypes.func,
  IconProfile: PropTypes.func,
  IconProfileAlternative: PropTypes.func,
  IconRecurring: PropTypes.func,
  IconRefresh: PropTypes.func,
  IconReturn: PropTypes.func,
  IconSalaryIncome: PropTypes.func,
  IconSavings: PropTypes.func,
  IconScale: PropTypes.func,
  IconSearch: PropTypes.func,
  IconServicePoint: PropTypes.func,
  IconSettings: PropTypes.func,
  IconShare: PropTypes.func,
  IconSign: PropTypes.func,
  IconSpeechBubble: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  IconSpendingCategories: PropTypes.func,
  IconStores: PropTypes.func,
  IconToDoorDelivery: PropTypes.func,
  IconToDoorDeliveryWithTimeslot: PropTypes.func,
  IconTransfers: PropTypes.func,
  IconTrash: PropTypes.func,
  IconTruck: PropTypes.func,
  IconWallet: PropTypes.func,
  IconWarning: PropTypes.func,
  KlarnaLogoFull: PropTypes.func,
  KlarnaLogoSingleLetter: PropTypes.func,
  /**
   * @missingPlatformSupport native
   */
  Loader: PropTypes.func,
  MaskedField: PropTypes.func,
  MenuTab: PropTypes.func,
  NavBar: PropTypes.func,
  NavBarActionBase: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  NavigationIconAssistant: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  NavigationIconHome: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  NavigationIconSpending: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  NavigationIconShopping: PropTypes.func,
  NavigationIconSustainability: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  NavigationIconTodo: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  OfferBreakdown: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  ParagraphPrimary: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  ParagraphSecondary: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  ParagraphTertiary: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  ParagraphQuaternary: PropTypes.func,
  Preview: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  PreviewLink: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  PreviewWithOptions: PropTypes.func,
  ProgressBar: PropTypes.func,
  'Radio.RadioOption': PropTypes.func,
  RadioBullet: PropTypes.func,
  RadioGroup: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  RadioResponsive: PropTypes.func,
  // Contrib component
  SelectorDirect: PropTypes.func,
  SelectorDirectOption: PropTypes.func,
  SelectorLogo: PropTypes.func,
  SelectorLogoOption: PropTypes.func,
  SelectorOptionBase: PropTypes.func,
  SelectorOptions: PropTypes.func,
  SpacerHorizontal: PropTypes.func,
  SpacerVertical: PropTypes.func,
  SwitchCheckbox: PropTypes.func,
  SwitchToggle: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  TitleDefinition: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  TitleDisplay: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  TitlePrimary: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  TitleSecondary: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  TitleSubtitle: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  TitleTertiary: PropTypes.func,
  Tooltip: PropTypes.func,
  Strong: PropTypes.func,
  /**
   * @deprecated removed with v6.0.0
   */
  UpsellPreview: PropTypes.func // Contrib component
};
//# sourceMappingURL=overridableComponents.js.map